import { Navigate, Route, Routes } from 'react-router-dom';

import { AuthProvider } from './components/auth/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { ModeToggle } from './components/mode-toggle';
import { GoogleAvatar } from './components/ui/google-avatar';
import { Toaster } from './components/ui/sonner';
import GoodJobMarine from './pages/GoodJobMarine';
import MediaRedirect from './pages/MediaRedirect';
import MissionReport from './pages/MissionReport';
import MissionReports from './pages/MissionReports';
import SignIn from './pages/SignIn';
import TestingGround from './pages/TestingGround';

const App = () => {
  return (
    <AuthProvider>
      <div className="flex h-screen flex-col">
        <div className="flex justify-between items-center">
          <div className="p-3">
            <GoogleAvatar />
          </div>
          <div className="p-4">
            <ModeToggle />
          </div>
        </div>
        <Toaster position="top-center" />
        <div className="flex-1">
          <Routes>
            <Route path="/sign-in" element={<SignIn />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/mission-reports/new" element={<MissionReport />} />
              <Route path="/mission-reports" element={<MissionReports />} />
              <Route path="/good-job" element={<GoodJobMarine />} />
              <Route path="/media/:id" element={<MediaRedirect />} />
              <Route path="/testing-ground" element={<TestingGround />} />
              <Route path="*" element={<Navigate to="/mission-reports/new" />} />
            </Route>
          </Routes>
        </div>
      </div>
    </AuthProvider>
  );
};

export default App;
